import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons';

function ScrollButton() {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    return (
        <>
            {/* eslint-disable-next-line */}
            <div
                className="fixed bottom-0 right-0 z-50 flex items-center justify-center bg-white border-0 rounded-full cursor-pointer shadow-1 hover:shadow-2 hack-bottom-6 hack-bottom-120px w-14 h-14"
                onClick={scrollToTop}
            >
                <FontAwesomeIcon
                    icon={faChevronUp}
                    className="font-medium text-[24px] text-blueGray-600 hover:text-blueGray-800"
                />
            </div>
        </>
    );
}

export default ScrollButton;
